import React from 'react'
import TimelineActionButtonProvider from 'redesign/services/timeline-action-button/timeline-action-button-provider'
import { TASK_TYPE_TITLE } from './constants'
import type { TaskDetailsProps } from './types'
import { getTaskDetailsComponent } from './utils'

const TaskDetails: React.FC<TaskDetailsProps> = ({ task, refetch }) => {
  const { taskType } = task

  if (!taskType || !(taskType in TASK_TYPE_TITLE)) return null

  const TaskDetailsComponent = getTaskDetailsComponent(taskType)

  return TaskDetailsComponent ? (
    <TimelineActionButtonProvider>
      <TaskDetailsComponent task={task} refetch={refetch} />
    </TimelineActionButtonProvider>
  ) : null
}

export default TaskDetails
